import React, { useState, useEffect } from 'react';
import Dropdown from 'react-dropdown-select';
import Service from "../Service/http";
import Util from "../Service/util";
import { SELECTED_OPTIONS_KEY } from "./../../constants";

function DropdownSelect( props ) {
  let service = new Service();
  let [configOptions , SetConfigOptions] = useState([])
  const handleSelectedOption = (selectedOptions) => {
    let selectedValues=selectedOptions.map((option)=>{
      return option.value
    })
    props.setSelectedOptions(selectedValues)
    localStorage.setItem(SELECTED_OPTIONS_KEY, JSON.stringify(selectedValues))
  };
  useEffect(() => {
    
      service.get("api/config/options")
      .then((json) =>{
        SetConfigOptions(json);
      })
      .catch((err)=>{
        console.log(err);
      })

  }, []);
  const allSelectableOptions = []
  const defaultSelectedOptions = []

  let optionObj
  let localStoredSiteOptions = JSON.parse(localStorage.getItem(SELECTED_OPTIONS_KEY))

  props.options.forEach((optionString) => {
    optionObj = {label: optionString, value: optionString}
    allSelectableOptions.push(optionObj)

    // use default selected-site-options if not available in local-storage
    if (localStoredSiteOptions === null) {
      defaultSelectedOptions.push(optionObj)
    }
  })

  // use local-stored selected-site-options if available
  if (localStoredSiteOptions !== null) {
    localStoredSiteOptions.forEach((optionString) => {
      optionObj = {label: optionString, value: optionString}
      defaultSelectedOptions.push(optionObj)
    })
  }

  let nonPlatformOptions = [
    { label: 'Info: CrawlTime', value: 'Info: CrawlTime' },
    { label: 'Info: FollowUp', value: 'Info: FollowUp' },
    { label: 'Info: Attendance', value: 'Info: Attendance'},
  ];
  if(configOptions.show_vqr == "true"){
    nonPlatformOptions.push({ label: 'Score: VQR Score', value: 'Score: VQR Score' })
  }
  if(configOptions.show_school_gpa == "true"){
    nonPlatformOptions.push({ label: 'User: School GPA/Percentage', value: 'User: School GPA/Percentage' })
  }
  if(configOptions.show_school_gpa == "true"){
    nonPlatformOptions.push({ label: 'User: Inter GPA/Percentage', value: 'User: Inter GPA/Percentage' })
  }


  nonPlatformOptions.forEach(optionObj => {
    allSelectableOptions.push(optionObj)
  });

  const dropdownConfig = {
    options: allSelectableOptions,
    values: defaultSelectedOptions,
    labelField: "label",
    valueField: "value",
    searchBy: "label",
    clearable: true,
    searchable:true,
    create: false,
    keepOpen: false,
    dropdownHandle: true,
    direction: "ltr",
    multi: true,
    keepSelectedInList: false,
    separator: true,
    dropdownPosition: "bottom",
    color: "#3498db",
    placeholder: "Select Sites",
  }

  return (
      <Dropdown
        options={dropdownConfig.options}
        values={dropdownConfig.values}
        onChange={(selected) => handleSelectedOption(selected)}
        placeholder={dropdownConfig.placeholder}
        searchBy={dropdownConfig.searchBy}
        clearable={dropdownConfig.clearable}
        searchable={dropdownConfig.searchable}
        create={dropdownConfig.create}
        keepOpen={dropdownConfig.keepOpen}
        dropdownHandle={dropdownConfig.dropdownHandle}
        direction={dropdownConfig.direction}
        multi={dropdownConfig.multi}
        labelField={dropdownConfig.labelField}
        valueField={dropdownConfig.valueField}
        keepSelectedInList={dropdownConfig.keepSelectedInList}
        separator={dropdownConfig.separator}
        dropdownPosition={dropdownConfig.dropdownPosition}
        color={dropdownConfig.color}
        onDropdownOpen={() => undefined}
        onDropdownClose={() => undefined}
        onClearAll={() => undefined}
        onSelectAll={() => undefined}
        noDataLabel="No matches found"
      />
  );
}

export default DropdownSelect;
